import InsuranceSection from './InsuranceSection';

export default InsuranceSection;
